module.exports = __webpack_public_path__ + "static/fonts/iconfont.4f4ba31.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.eot
// module id = 41FU
// module chunks = 1